export default __webpack_public_path__ + "static/media/HealthCoach.1ce6a877.webp";